export function rebateTooltip(offerType) {
  switch (offerType) {
    case 'takepay':
    case 'general':
    case 'percentage':
      return 'Equivale ao total de desconto concedido através dos produtos na oferta.'
    case 'nextbuycashback':
      return 'Equivale ao total de cashback consumido até a data de validade do cashback.'
    case 'cashback_absolute':
      return 'Equivale ao total de cashback gerado no período da campanha.'
    case 'crosssell':
      return 'Total de desconto concedido nos produtos alvo da oferta.'
  }
  return ''
}
